export const fetchBookingsByStatus = (status) => {
  return `/booking/${status}`;
};

export const fetchPreferPartnerURL = (source_city, destination_city) => {
  return `/booking/get-top-route-vendors?source_city=${source_city}&destination_city=${destination_city}`;
};

export const fetchBookingDetailsURL = (booking_id, url) => {
  return `/booking/${url}/${booking_id}`;
};

export const reviveBookingURL = () => {
  return `/booking/revive-booking`;
};

export const deactivateBookingURL = () => {
  return `/booking/deactivate-booking`;
};

export const activateBookingURL = () => {
  return `/booking/activate-booking`;
};

export const rejectBookingURL = () => {
  return `/booking/reject-booking`;
};

export const assignBookingURL = () => {
  return `/booking/assign-booking`;
};

export const reassignBookingURL = () => {
  return `/booking/assign-booking`;
};

export const dockBookingURL = () => {
  return `/booking/dock-booking`;
};

export const fetchBookingByIdURL = () => {
  return '/booking/booking-details';
};

export const createBookingURL = () => {
  return '/booking/create-booking';
};

export const editBookingURL = () => {
  return '/booking/edit-booking';
};

export const acceptBookingURL = () => {
  return '/booking/accept-booking';
};

export const fetchCitiesByCustomerURL = (customer) => {
  return `/booking/cities/${customer}`;
};

export const fetchProcuredByURL = () => {
  return `/booking/load-procured-users`;
};

export const checkDockConditionURL = () => {
  return `/booking/check-dock-conditions`;
};

export const fetchTatAndDistanceURL = () => {
  return `/booking/autofill-tat-distance`;
};

export const fetchAvailableVehiclesURL = (search) => {
  return `/vehicle/available-vehicles${search ? '?' + search : ''}`;
};

export const downloadAvailableVehiclesReportURL = (search) => {
  return `/vehicle/available-vehicles-report${search ? '?' + search : ''}`;
};

export const downloadDockReportURL = () => {
  return `/booking/download-dock-report`;
};

export const downloadBookingReportURL = (status) => {
  return `/booking/download-booking-report/${status}`;
};

export const downloadAllOrdersReportURL = (queryParams) => {
  return `/trip/download-order-report${queryParams}`;
};

export const sendToLoadBoardURL = () => {
  return `/booking/edit-loads`;
};

export const fetchBookingBidsURL = (bookingId) => {
  return `/booking/pull-vendor-bids?booking_id=${bookingId}`;
};

export const closeBidURL = () => {
  return `/booking/close-loads`;
};

export const addBidDetailsURL = () => {
  return '/booking/create-bids';
};

export const updateBidURL = () => {
  return '/booking/update-bids';
};

export const fetchAvailableVehicleReportURL = (search) => {
  return `/vehicle/available-vehicle-days${search ? '?' + search : ''}`;
};

export const fetchBookingCommentsURL = (booking_id) => {
  return `/booking/booking-comment/${booking_id}`;
};

export const addBookingCommentsURL = (booking_id) => {
  return `booking/booking-comment/${booking_id}`;
};

export const addBookingsLocationURL = () => {
  return `/booking/booking-add-location-manual`;
};

export const chartDataURL = () => {
  return `/booking/chart-data`;
};

//chart data URL for vendor Graph
export const fetchVendorGraphDataURL = (vendor_name, vendor_period) => {
  return `/booking/chart-data?vendor_name=${vendor_name}&vendor_period=${vendor_period}`;
};

//po mapping
export const fetchPOMappingURL = () => {
  return `/trip/fetch-po-mapping`;
};

//orders

export const fetchAllOrdersDataUrl = (status, page, search) => {
  return `trip/indent-order?order_type=${status}&page=${page}${search}`;
};

export const orderActionURL = () => {
  return `/trip/order-action`;
};

export const fetchAllOrdersSupportingDocDataUrl = (status, id) => {
  return `trip/indent-order?${
    status ? 'order_type=' + status + '&' : ''
  }record_id=${id}`;
};

export const uploadAllOrdersDocURL = () => {
  return `/trip/upload-booking-task-docs`;
};

export const orderReferenceURL = () => {
  return `/trip/order-reference-change`;
};

export const orderUpdateManualLocationURL = () => {
  return `/trip/order-update-manual-location`;
};

export const orderDriverPhoneURL = () => {
  return `trip/order-driver-phone-change`;
};

//indents
export const fetchAllIndentDataUrl = (status, page, search) => {
  return `/customer/customer-indent/?status=${status}&page=${page}${search}`;
};

export const fetchIndentDataUrl = (customer_id) => {
  return `/customer/customer-indent/indent-master/?customer_id=${customer_id}`;
};

export const fetchIndentInitialDataUrl = () => {
  return `/customer/customer-indent/indent-initial-data/`;
};

export const fetchEditIndentDataUrl = (indentId) => {
  return `/customer/customer-indent/${indentId}/`;
};

export const createIndentDataUrl = (indentId) => {
  return `/customer/customer-indent/${indentId ? indentId + '/' : ''}`;
};

export const indentOrderDetailsURL = (orderId) => {
  return `/booking/indent-order-details?order_id=${orderId}`;
};

export const orderTasksDetailsURL = (orderId) => {
  return `/booking/indent-order-task?order_id=${orderId}`;
};

export const indentOrderDocumentsURL = (orderId) => {
  return `/booking/indent-order-document?order_id=${orderId}`;
};
export const indentUpdateOrderDocumentsURL = () =>
  '/booking/indent-order-document';
export const fetchIndentBidsURL = (indentId) => {
  return `/booking/pull-vendor-bids?indent_id=${indentId}`;
};

export const updateIndentBidURL = () => {
  return '/booking/update-bids';
};

export const blockIndentURL = () => {
  return `/customer/customer-indent/create-order/`;
};

export const reviveIndentURL = () => {
  return `/trip/revive-indent-expiry`;
};

export const closeIndentURL = () => {
  return `trip/close-indent`;
};

export const addAdhocRateURL = (query = '') => {
  return `/customer/customer-indent/add-adhoc-rate/${query}`;
};

export const deleteAdhocRateURL = (query = '') => {
  return `customer/customer-indent/delete-adhoc-rate/`;
};

export const fetchIndentOrdersURL = (indentId) => {
  return `/customer/customer-indent/get-all-orders/?indent_id=${indentId}`;
};
export const submitOrderDetailsURL = () => {
  return `/booking/order-details-action`;
};

export const deleteOrderSupportingDocsURL = () => {
  return `/trip/upload-booking-task-docs`;
};

export const verifysubmitTaskDocsURL = () => {
  return `/trip/verify-submit-task-docs`;
};

export const fetchOrderAdjustmentURL = (sourceOrderId, targetOrderId) => {
  return `/finance/delta-amount-adjustment/?source_order=${sourceOrderId}&target_order=${targetOrderId}`;
};

export const submitOrderAdjustmentURL = () => {
  return `/finance/delta-amount-adjustment/`;
};

//ewaybillCheckRquest
export const ewaybillCheckRquestURL = () => {
  return `customer/eway-bill-extend`;
};

export const rejectIndentOrderPaymentURL = () =>
  '/booking/indent-order-reject-payment';

export const holdPaymentURL = () => '/booking/indent-order-hold-payment';
